/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaInputDatePicker/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaInputDatePicker({
  children,
  viewPath = "/DesignSystem/TysiaInput/TysiaInputDatePicker",
  innerRef,
  left,
  top
  
}) {
let dtTysiainputdatepickerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.backgroundColor.primary.base'
        })
let dtTysiainputdatepickerBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.borderColor.primary.base'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="TysiaInputDatePicker.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--bc-1-Z1NnCnK': dtTysiainputdatepickerBackgroundcolorPrimaryBase,'--bc-2-Z1NnCnK': dtTysiainputdatepickerBordercolorPrimaryBase,'--l-3-Z1NnCnK': typeof left === 'number' ? `${left}px` : left,'--t-4-Z1NnCnK': typeof top === 'number' ? `${top}px` : top}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
)}
</FloatingPortal>
</React.Fragment>)
}